export const PAGE_MAX_WIDTH = 970
export const TABLET_MAX_WIDTH = 768
export const MOBILE_MAX_WIDTH = 520
export const DESKTOP_MIN_WIDTH = 769
export const LARGE_DESKTOP_MIN_WIDTH = 1200
